export default {"src":"/_next/static/media/ico-talons.7cc273e9.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};